/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';

class Counterlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            counter_data: []
        };
    }
    componentDidMount() {
        const { slug } = this.props.match.params
        if (slug !== null && slug !== undefined && slug !== '') {
            this.fetchData(slug);
        }
    }
    fetchData(tvId) {
        const { getTvCounterWithNoAuth } = networkList;

        postService(getTvCounterWithNoAuth, 'POST', { 'data': { "tv_display_id": tvId } }).then((res) => {
            if (res) {
                this.setState((state) => ({
                    counter_data: res.data.sort(function (a, b) {
                        if (a.queue_list_id < b.queue_list_id) { return -1; }
                        if (a.queue_list_id > b.queue_list_id) { return 1; }
                        return 0;
                    })
                }));
                this.interval = setTimeout(() => this.fetchData(tvId), 5000);
            }
            if (!res) {
                this.fetchData(tvId);
            }

        });

    }
    getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }


    render() {
        return (
            <div className="container-fluid">
                <div className="tv-counter-data">
                    <div className="py-3 counter-card h-100">
                        <div className="row">
                            <div className="col-12">
                                <div className="col-12 reports-details counter-details">
                                    <div className="card">
                                        <table>
                                            <thead>
                                                <tr className="row head-row">
                                                    {/* <th className="col-3 my-auto">Doctor</th> */}
                                                    <th className="col-3 my-auto">Room No</th>
                                                    <th className="col my-auto">NOW</th>
                                                    <th className="col my-auto">NEXT</th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div className="card">
                                        <table className="table-body">
                                            <tbody>
                                                {this.state.counter_data.map((data, key) => {
                                                    let now = [];
                                                    let next = [];
                                                    data.queue_rows.map((row, rkey) => {
                                                        if (row.checkKey !== undefined && row.checkKey !== null) {
                                                            if (row.checkKey === 'now') {
                                                                now.push(row);
                                                            }
                                                            if (row.checkKey === 'next') {
                                                                next.push(row);
                                                            }
                                                        }

                                                    })

                                                    /* commenting the umr limit code
                                                    if(now.length !== 0) { 
                                                        let nowumr = now[0].umr 
                                                        now[0].umr = nowumr.substr(nowumr.length - 5)
                                                    };
                                                    if(next.length !== 0) {
                                                        let nextumr = next[0].umr;
                                                        next[0].umr = nextumr.substr(nextumr.length - 5)
                                                    }    */
                                                    return (
                                                        <tr className="row tv-row" key={key}>
                                                            <td className="col-3 my-auto order-1">{data.queue_list_id}</td>
                                                            {(now.length === 0) && <td className="col my-auto order-2">--</td>}
                                                            {(now.length !== 0) && <React.Fragment><td className="col my-auto order-3" >{now[0].umr}</td></React.Fragment>}
                                                            {(next.length === 0) && <td className="col my-auto order-3">--</td>}
                                                            {(next.length !== 0) && <React.Fragment><td className="col my-auto order-3">{next[0].umr}</td></React.Fragment>}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Counterlist;
